/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ConsentChoiceInChoice = typeof ConsentChoiceInChoice[keyof typeof ConsentChoiceInChoice];


export const ConsentChoiceInChoice = {
  granted: 'granted',
  declined: 'declined',
} as const;
